import React from 'react';
import { Search } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

export const CoursesHero = ({ q, setQ }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  return (
    <div className="text-center pt-2 pb-6">
      <h1 data-testid="courses-title" className="text-3xl sm:text-4xl lg:text-[2.75rem] font-black text-slate-900 tracking-tight mb-3">{L('الكورسات', 'Courses')}</h1>
      <p className="text-slate-500 text-sm sm:text-base max-w-xl mx-auto">{L('مجموعة متكاملة من الكورسات المصممة بعناية لتعلم الأتمتة من الصفر وحتى الاحتراف', 'A complete set of carefully designed courses to learn automation from zero to pro')}</p>
      <div className="relative max-w-2xl mx-auto mt-6">
        <Search className="absolute top-1/2 -translate-y-1/2 start-4 w-5 h-5 text-slate-400 pointer-events-none" />
        <input data-testid="courses-search-input" value={q} onChange={e => setQ(e.target.value)} placeholder={L('ابحث عن كورس، مثل: PLC أو Siemens ...', 'Search a course, e.g. PLC or Siemens ...')}
          className="w-full h-12 sm:h-14 rounded-2xl bg-white border border-slate-200 shadow-[0_6px_24px_-10px_rgba(15,23,42,0.15)] ps-12 pe-4 text-sm outline-none focus:border-blue-400 focus:ring-4 focus:ring-blue-100 transition-[border-color,box-shadow]" />
      </div>
    </div>
  );
};
